import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class LinkIssueService {
	readonly url: string = 'LinkIssue';

	constructor(private http: HttpClient) {}

	public FixLinkIssue(linkIssueReport: any): Observable<string> {
		return this.http.post(this.url + '/fixLinkIssue', linkIssueReport, { responseType: 'text' as 'text' });
	  }

}
